import React, { FC, useMemo } from "react";

import { useProvidersCurrentEmployee } from "~/hooks";

import { getManagerNavigationConfig } from "~/config/NavigationConfig";

import { SidebarLink } from "./SidebarLink";

import {
  ApiMembersUnreadNotificationCountsType,
  NavigationItemCompanyType,
  OwnerRole,
} from "~/domains";

import { Accordion } from "~/ui";

type PropsType = {
  breadCrumbText: string;
  unreadNotification?: ApiMembersUnreadNotificationCountsType;
  navigationItems?: NavigationItemCompanyType[];
};

export const ManagerSidebar: FC<PropsType> = ({
  breadCrumbText,
  unreadNotification,
  navigationItems,
}: PropsType) => {
  const { currentEmployee } = useProvidersCurrentEmployee();
  const defaultBusinessSectionId =
    currentEmployee?.businessSections[0]?.id || "";

  // navigationConfigをメモ化
  const navigationConfig = useMemo(
    () => getManagerNavigationConfig(defaultBusinessSectionId),
    [defaultBusinessSectionId],
  );

  // hiddenAtでフィルタリングして表示するナビゲーション項目を取得
  const displayNavs =
    navigationItems
      ?.filter((item) => item.role === "manager" && !item.hiddenAt)
      .sort((a, b) => a.position - b.position) || [];

  return (
    <>
      {displayNavs.map((nav, index) => {
        const navConfig = navigationConfig[nav.name];
        if (navConfig?.lists) {
          return (
            <Accordion
              key={`${nav.id}-${index}`}
              buttonClassName={`px-4 py-2 font-medium truncate ${
                breadCrumbText === nav.name
                  ? "bg-primary-600 text-white"
                  : "hover:bg-primary-300"
              }`}
              iconColor={
                breadCrumbText === nav.name
                  ? "text-white"
                  : "text-secondary-600"
              }
              title={nav.name}
              // FIXME: もっと良い書き方ありそう
              lists={navConfig.lists.filter((list) =>
                list.isOwnerOnly
                  ? currentEmployee?.employeeRole.type === OwnerRole.type
                  : true,
              )}
              isDefaultOpen={breadCrumbText === nav.name}
            />
          );
        } else if (navConfig?.href) {
          return (
            <SidebarLink
              key={`${nav.id}-${index}`}
              label={nav.name}
              href={navConfig.href}
              breadCrumbText={breadCrumbText}
              unreadNotification={unreadNotification}
            />
          );
        } else {
          return (
            <hr
              key={`${nav.id}-${index}`}
              className="bg-secondary-300 my-2 mx-4"
            />
          );
        }
      })}
    </>
  );
};
